import React from "react";
import GlassCard from "./GlassCard";
import { trustSectionContent } from "../data/trustSectionContent";

const TrustSection = ( {lang = "sl" } ) => {
  const t = trustSectionContent[lang];

  return (
    <section>
      <div className="container" style={{ maxWidth: 1040 }}>
        <GlassCard
          style={{
            borderRadius: 32,
            padding: "28px 28px 24px",
          }}
        >
          <h2
            style={{
              marginTop: 0,
              marginBottom: 8,
              textAlign: "center",
              color: "#176B87",
              fontSize: 26,
            }}
          >
            {t.title}
          </h2>
          <p
            style={{
              textAlign: "center",
              marginBottom: 24,
              color: "var(--text-muted)",
            }}
          >
            {t.description}
          </p>

          {/* Stats + mini testimonials */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: 20,
            }}
          >
            <GlassCard
              style={{
                borderRadius: 20,
                padding: "18px 20px",
                background: "rgba(255,255,255,0.8)",
              }}
            >
              <div
                style={{
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#176B87",
                  marginBottom: 4,
                }}
              >
                90%
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: "var(--text-muted)",
                }}
              >
                {t.block1Text}
              </div>
            </GlassCard>

            <GlassCard
              style={{
                borderRadius: 20,
                padding: "18px 20px",
                background: "rgba(255,255,255,0.8)",
              }}
            >
              <div
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  marginBottom: 6,
                }}
              >
                {t.block2Title}
              </div>
              <p
                style={{
                  margin: 0,
                  fontSize: 13,
                  color: "var(--text-muted)",
                }}
              >
                {t.block2Text}
              </p>
            </GlassCard>

            <GlassCard
              style={{
                borderRadius: 20,
                padding: "18px 20px",
                background: "rgba(255,255,255,0.8)",
              }}
            >
              <div
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  marginBottom: 6,
                }}
              >
                {t.block3Title}
              </div>
              <p
                style={{
                  margin: 0,
                  fontSize: 13,
                  color: "var(--text-muted)",
                }}
              >
                {t.block3Text}
              </p>
            </GlassCard>
          </div>

          <p
            style={{
              marginTop: 16,
              fontSize: 11,
              color: "var(--text-muted)",
              textAlign: "center",
            }}
          >
            ({t.warning})
          </p>
        </GlassCard>
      </div>
    </section>
  );
};

export default TrustSection;
